export const CommonConstant = {
  ASCENDING: "asc",
  DESCENDING: "desc",
  DATE_FORMAT: "dd/MM/yyyy",
}
